export const formatPhone = (phone: string|undefined) => {
  if (!phone) return "";

  const clean = phone.toString().replace(/\D/g, "");

  const normalized =
    clean.startsWith("8") && clean.length === 11
      ? "7" + clean.slice(1)
      : clean;

  if (normalized.length === 11 && normalized.startsWith("7")) {
    return `+7 (${normalized.slice(1, 4)}) ${normalized.slice(4, 7)}-${normalized.slice(7, 9)}-${normalized.slice(9, 11)}`;
  }

  return phone;
};
